import React from 'react';

import { removeDevice } from '@/features/login/slice';
import MfaIcon from '@/features/mfa/components/MfaIcon';
import { resetSkipped } from '@/features/mfa/slice';
import { withAuthLayout } from '@/layouts/Auth';

import { Action } from '@bypasslane/clover--web-lib-sprout-action';
import { Card, CardBody } from '@bypasslane/clover--web-lib-sprout-card';
import { Heading } from '@bypasslane/clover--web-lib-sprout-heading';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

const NoDevices = ({ devicesLoaded = false, devices = [] }) => {
  if (!devicesLoaded || devices.length > 0) {
    return;
  }

  const dispatch = useDispatch();

  function handleAddDeviceClick() {
    dispatch(resetSkipped());
  }

  return (
    <Card className="flex-1 mx-3 my-1">
      <CardBody>
        <Heading headingLevel="h3" className="text-left py-4">
          <Action fullwidth onClick={handleAddDeviceClick}>
            Add a new device
          </Action>
        </Heading>
      </CardBody>
    </Card>
  );
};

export const MfaDevices = ({
  devices = [],
  getTypeDetails,
  devicesLoaded = false,
  sectionTitle = 'SMS Phone Authentication',
  description = 'Manange your two-factor authentication devices'
}) => {
  const dispatch = useDispatch();

  const handleRemove = (deviceId) => () => {
    dispatch(removeDevice({ id: deviceId })); // Ensure the correct device ID is passed
  };

  return (
    <div className="flex flex-col">
      <Heading headingLevel="h3" title="Two-factor authentication" className="text-left" />
      <NoDevices devicesLoaded={devicesLoaded} devices={devices} />
      {devices.map((device) => (
        <Card key={device.id} className="flex-1">
          <CardBody>
            <Heading headingLevel="h3" className="text-left">
              {sectionTitle}
            </Heading>
            <p className="text-sm text-gray-700 text-left mb-4">{description}</p>
            <div className="flex justify-between items-center mb-4 mt-4">
              <MfaIcon className="h-12 w-12" device={device} />
              <div className="ml-4">{getTypeDetails(device)}</div>
              <div className="flex space-x-4">
                <Action onClick={handleRemove(device.id)} variant="flat" destructive>
                  Remove
                </Action>
              </div>
            </div>
          </CardBody>
        </Card>
      ))}
    </div>
  );
};

export default withAuthLayout(MfaDevices, {
  enableProfiler: true,
  enableErrorBoundary: true
});
export { AddDeviceContainer } from './AddDeviceContainer';
MfaDevices.propTypes = {
  devices: PropTypes.array.isRequired,
  getTypeDetails: PropTypes.func.isRequired,
  devicesLoaded: PropTypes.bool,
  sectionTitle: PropTypes.string,
  description: PropTypes.string
};
NoDevices.propTypes = {
  devicesLoaded: PropTypes.bool,
  devices: PropTypes.array.isRequired
};
NoDevices.displayName = 'NoDevices';
MfaDevices.displayName = 'MfaDevices';
